import type { SVGProps } from 'react';

export function SolanaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.88 10.03a.8.8 0 0 0-.572-.242H2.898a.8.8 0 0 0-.573 1.358l2.797 2.868a.8.8 0 0 0 .573.241h15.408a.8.8 0 0 0 .573-1.358zM5.12 3.242A.8.8 0 0 1 5.692 3h15.41a.8.8 0 0 1 .573 1.359l-2.797 2.867a.8.8 0 0 1-.573.242H2.897a.8.8 0 0 1-.573-1.359zM5.12 16.774a.8.8 0 0 1 .572-.242h15.41a.8.8 0 0 1 .573 1.359l-2.797 2.868a.8.8 0 0 1-.573.241H2.897a.8.8 0 0 1-.573-1.358z" />
    </svg>
  );
}
